import { z } from 'zod';

export const formSchema = z.object({
  id: z.number(),
  equipmentCode: z.string().min(1, 'Obrigatório'),
  containerCode: z.string().min(1, 'Obrigatório'),
  companyId: z.string(),
});

export type FormSchema = z.infer<typeof formSchema>;